/* eslint-disable no-fallthrough, import/no-default-export */
const analyticsWebClient = require('@atlassiansox/analytics-web-client');
import ClientConfig from './client-config';

const { envType, originType, platformType } = analyticsWebClient;
const { analyticsWebClientEnv, clientVersion } = window;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const analyticsContext: any = ClientConfig.get('analyticsContext');
const isDesktop: boolean = ClientConfig.get('appId') === 'desktop';

interface AnalyticsWebClientConfig {
  env: string;
  product: string;
  version: string;
  origin: string;
  platform: string | null;
}

const config = {
  env: envType[analyticsWebClientEnv],
  product: 'trello',
  version: clientVersion,
  origin: isDesktop ? originType.DESKTOP : originType.WEB,
  platform: null,
} as AnalyticsWebClientConfig;

if (analyticsContext) {
  switch (analyticsContext.platform) {
    case 'darwin':
      config.platform = platformType.MAC;
      break;
    case 'win32':
      config.platform = platformType.WINDOWS;
      break;
    case 'linux':
      config.platform = platformType.LINUX;
    default:
  }
}

export default new analyticsWebClient.default(config);



// WEBPACK FOOTER //
// ./app/common/debug/behavioral-analytics.ts